// Related tab: the products this one links to by hand — related ("you may
// also like", before the computed recommendations) and cross-sell (what goes
// with it) — each a list of pids in the order the page shows them.
import React from "react"
import Typography from "aldoo-ra/Typography"
import ProductListPicker from "./ProductListPicker"

function Block({ title, description, children }) {
  return (
    <section className="flex flex-col gap-2">
      <Typography variant="admin_body1" className="font-semibold my-0">
        {title}
      </Typography>
      <Typography variant="admin_body2" className="opacity-70 my-0">
        {description}
      </Typography>
      {children}
    </section>
  )
}

export default function RelatedTab({ value = {}, onChange }) {
  return (
    <div className="flex flex-col gap-8" data-testid="related-tab">
      <Block title="Related products" description="Shown on the product page before the computed recommendations.">
        <ProductListPicker value={value.related} exclude={value.pid} onChange={(related) => onChange?.({ related })} testId="related-picker" />
      </Block>
      <Block title="Cross-sell" description="What goes with this product (accessories, the other half of a set).">
        <ProductListPicker value={value.crossSell} exclude={value.pid} onChange={(crossSell) => onChange?.({ crossSell })} testId="cross-sell-picker" />
      </Block>
    </div>
  )
}
